import React, { Component } from 'react';
import ScrollAnimation from 'react-animate-on-scroll';
import './Kontakt.css';
import Content from '../Content/Content';

var kontakth1 = {
    marginBottom: '3em'
};
var span = {
    marginLeft: '4.65vw'
};
class Kontakt extends Component {
    render () {
        return (
            <Content>
            <div className="conDiv">
                <ScrollAnimation animateIn="fadeInDown" animateOnce="true">
                <h1 style={kontakth1}>Kontakt</h1>
                </ScrollAnimation>
                <div className="mapa">
                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3334.7341233468205!2d16.708455684780347!3d52.429826672624735!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4704470ffbc991bb%3A0x735659eca91b00a3!2sStara%20Wozownia%20Izabela%20Halas%20Sp%C3%B3%C5%82ka%20Jawna!5e0!3m2!1spl!2spl!4v1573231502332!5m2!1spl!2spl" width="100%" height="100%" frameborder="0" allowfullscreen=""></iframe>
                </div>
                <div className="dane">
                    <ul>
                        <li><strong style={{width: '100% !important'}}>Willa Stara Wozownia</strong></li>
                        <li><span><strong>Adres:</strong></span><span> ul. Nowa 35 <br/>62-080 Lusowo k. Poznania</span></li>
                        <li><span><strong>Tel.:</strong></span><span>+48 725 520 620<br/>+48 607 577 052</span></li>
                        <li><span><strong>E-Mail:</strong></span><span> biuro@willastarawozownia.pl</span></li>
                        
                    </ul>
                </div>
            </div>
            </Content>
        );
    }
}

export default Kontakt;


// WEBPACK FOOTER //
// ./src/Kontakt/Kontakt.js